"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const polished_1 = require("polished");
const styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
exports.default = styled_components_1.default.div `
  height: 100%;
  margin: 0 ${polished_1.rem(4)};
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;
